import { Map as IMap, List as IList, Set as ISet } from 'immutable';
import { createSelector } from 'reselect';

import { getCurrencyCodes } from '../item/itemSelectors';
import {
    AMOUNT_FIELD,
    FACEPLATE_FIELD,
    IS_PLASTIC_FIELD,
    PROGRAM_CODE,
    CURRENCY_FIELD
} from '../item/newItemForm';

import { history } from './routing';



export const getFlowState = state => state.get('flow', IMap());


export const getFlowConfig = createSelector(
    getFlowState,
    flow => flow.get('flowConfig')
);


export const getBuyFlowConfig = createSelector(
    getFlowConfig,
    flowConfig => flowConfig.get('buy')
);


export const getPostBuyFlowConfig = createSelector(
    getFlowConfig,
    flowConfig => flowConfig.get('postBuy')
);


export const getStepConfigs = createSelector(
    getFlowState,
    flow => flow.get('stepConfigs')
);


export const getHomePath = createSelector(
    getBuyFlowConfig,
    flowConfig => flowConfig.first()
);


export const getPathStepConfig = createSelector(
    state => state.getIn(['flow', 'stepConfigs'], IMap()),
    stepConfigs => path => stepConfigs.get(path)
);


export const getLocationStepConfig = (state, location) => {
    const { pathname } = location; 
    const pathParts = new IList(pathname.split('/'))
        .shift() 
        .filter(part => part !== ''); 
    const found = getPathStepConfig(state)(pathParts.last());
    return found || IMap();
};


export const getCurrentLocationStepConfig = (state) => {
    const currentLocation = history.location;
    return getLocationStepConfig(state, currentLocation);
};


export const getShowCartPaths = createSelector(
    getStepConfigs,
    stepConfigs => stepConfigs
        .filterNot(config => config.get('hideCartLink', false))
        .keySeq()
        .map(path => `*/${path}`)
        .toArray()
);


export const getDisplayBannerPaths = createSelector(
    getStepConfigs,
    stepConfigs => stepConfigs
        .filterNot(config => config.get('hidePromoBanner', false))
        .keySeq()
        .map(path => `*/${path}`)
        .toArray()
);

export const getFlowProgressState = state => state.get('flowProgress', IMap());

export const getFlowProgress = createSelector(
    getFlowProgressState,
    flowProgress => flowProgress.get('progress', ISet())
);

export const getPreferredValues = createSelector(
    getFlowProgressState,
    flowProgress => flowProgress.get('preferredValues', IMap())
);

export const getPreferredPaymentValues = createSelector(
    getFlowProgressState,
    flowProgress => flowProgress.get('preferredPaymentValues', IMap())
);

export const getPreferredAmount = createSelector(
    getPreferredValues,
    values => (values ? values.get(AMOUNT_FIELD, 0) : 0)
);

export const getPreferredFaceplateCode = createSelector(
    getPreferredValues,
    values => (values ? values.get(FACEPLATE_FIELD, null) : null)
);

export const getPreferredCardType = createSelector(
    getPreferredValues,
    values => (values ? values.get(IS_PLASTIC_FIELD, null) : null)
);

export const getPreferredClassicGift = createSelector(
    getPreferredValues,
    values => (values ? values.get('preferredClassicGift', null) : null)
);

export const getPreferredProgramCode = createSelector(
    getPreferredValues,
    values => (values ? values.get(PROGRAM_CODE, null) : null)
);


export const getPreferredCurrencyCode = createSelector(
    getPreferredValues,
    getCurrencyCodes,
    (values, currencyCodes) => (currencyCodes.isEmpty() ? values.get(CURRENCY_FIELD, null) : null)
);

export const getPreferredLoyaltyNumber = createSelector(
    getPreferredPaymentValues,
    preferredPaymentValues => preferredPaymentValues.get('loyaltyNumber', null)
);
